module["exports"] = ["###-###-####", "(###)-##-###-####", "+(###)-##-###-####", "+###-##-###-####", "1-###-###-####", "### ### ####"];